import { render, staticRenderFns } from "./Subject-edit-person-form.vue?vue&type=template&id=da64edf8"
import script from "./Subject-edit-person-form.vue?vue&type=script&lang=js"
export * from "./Subject-edit-person-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports